export const environment = {
    production: false,
    // story: `/api/story`,
    // events: `ws://${window.location.hostname}:${window.location.port}/ws/events`,
    // notification: `/api/notification`,
    story: `https://gamesis.eu/api/story`,
    events: `wss://gamesis.eu/ws/events`,
    notification: `https://gamesis.eu/api/notification`,
    timeout: 3000,
    firebase: {
        apiKey: 'AIzaSyAKypEET52ywIfvli7P4Cl-HP35YupJE_k',
        authDomain: 'gamesis.firebaseapp.com',
        storageBucket: 'gamesis.appspot.com',
        messagingSenderId: '164832549894',
        projectId: 'gamesis',
        appId: '1:164832549894:web:7d6a010798f114d2c93787',
        vapidKey: 'BKvRiEUTxwsYG59QVqAcMULWvcn3gApdgZ3MQuw1FRBDFHy0wdEj1j6V-QujyG_Yy7mcUBtb6mn34wcXex7gSYw'
    }
};
